import React, { useEffect, useState } from 'react'
import ContactsLayout from '../ContactsLayout';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { useLocation, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import * as yup from 'yup';
import { GetAccess } from '../../../../Components/Utils/roles';
import MobileContractorsIndex from '../../../Mobile/Contacts/MainContractors/MobileContractorsIndex';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { NuDate } from '../../../../Components/Utils/Input';
import NuDateFormate, { formatDate } from '../../../../Components/Utils/NuDate';

import CloseIcon from '../../../../Components/Icons/Close';
import axiosInstance from '../../../../Services/axiosCommon';
import ImportConsultants from './ImportConsultants';
import MultiEditConslt from './MultiEditConsult';
import MobileConsultIndex from '../../../Mobile/Contacts/Consultants/MobileConsultIndex';
import ConsultantCard from './ConsultantCard';
import Pagination from '../../../../Components/Utils/Pagenation';
import useFetchMetaStar from '../../../../Components/Hooks/useFetchMetaStar';
import { CountryMIN } from '../../../../assets/CountryMini';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import ImportFileModal from '../../../../Components/Utils/ImportFileComponent';




function ConsultantsIndex() {
  const { officeId } = useParams();
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);
  
  const { value: Category, getData: refCategory } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Category_Contractor",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
 );
   const { value: Rating } = useFetchMetaStar(
     `/dropdown/dropdown-details/`,
     "ratings",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
   );
   const { value: Type, getData: refType } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Type_Contractor",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
  );
  const { value: Status, getData: refStatus } = useFetchMDIndex(
   `/dropdown/dropdown-details/`,
   "statusClient",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
 );
    const [screenSize, setScreenSize] = useState({
           width: window.innerWidth,
         });
       
         useEffect(() => {
           const handleResize = () => {
             setScreenSize({
               width: window.innerWidth,
             });
           };
       
           window.addEventListener("resize", handleResize);
       
           return () => {
             window.removeEventListener("resize", handleResize);
           };
         }, []);
  
        
  
   const location = useLocation();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const [page, setPage] = useState(currentPage||1)
   const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const state = location.state;
   const [filter, setFilter] = useState(
     state?.vendorStatus || state?.category ? true : false
   );
     const [filterProps, setFilterProps] = useState({
   
      performanceRating:"",
      vendorType:"",
      category:"",
      vendorStatus:"",
   
      country:"",
     });
   const [params, setParams] = useState({
     page: page,
     per_page: pageCount,
     search:searchQuery||"",
  
     performanceRating:"",
    type:4,

      vendorType:"",
      // category:"",
      // vendorStatus:"",
      vendorStatus:"",
      country:"",
      category:"",
      vendorStatus:state?.vendorStatus? state.vendorStatus :"",
     category:state?.category? state.category :"",
   });
  
   const clearFilter = ()=> {
     setParams({...params,performanceRating:"", vendorStatus:"", vendorType:"",country:"", vendorStatus:"",category:"",})
     formik.values.performanceRating=""
     formik.values.vendorStatus=""
     formik.values.category=""
     formik.values.vendorType=""
     formik.values.country=""
  
  
  
       setFilter(false)
   }
  
   const formik = useFormik({
     enableReinitialize: true,
     initialValues: filterProps,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema: yup.object({
       // email: yup.string().required('Email is required!'),
     }),
     onSubmit: async (value, { resetForm }) => {
        await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
       setParams({...params,performanceRating:value.performanceRating, vendorType:value.vendorType, category:value.category, vendorStatus:value.vendorStatus, country:value.country,})
       closeFilterDialog();
       setFilter(true)
       setFilterProps({
        performanceRating:"",
        vendorType:"",
        category:"",
        vendorStatus:"",
     
        country:"",
       });
     }
   })
  
   const { data, getData,dataLoading,totalCount } = UseGetDataSearch( `/suppliers/listing`,params);
    const [viewMode, setViewMode] = useState(localStorage.getItem("viewMode") || "card");
// const totalCount = dummyData.length;

   
  
   const defaultHeader = [
    {
      title: "Ref.",
      width: "10%",
      isLink: true,
      id: "supplierId",
      link: `/contacts/consultants/view/`,
      field: "refNumber",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Company ",
      width: "15%",
      isLink: true,
     
      id: "supplierId",
      link: `/contacts/consultants/view/`,
      field: "companyName",
      textAlign: "left",
      rowAlign: "left",
    },
    // {
    //   title: "Location",
    //   width: "10%",
    //   field: "city",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },
    {
      title: "Type",
      width: "10%",
      field: "vendorType",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Mobile",
      width: "10%",
      field: "phoneWithCC",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Email",
      width: "15%",
      field: "email",
      type: "email",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "City",
      width: "10%",
      field: "city",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status",
      width: "10%",
      field: "vendorStatus",
      textAlign: "left",
      rowAlign: "left",
    },
     {
       title: "Action",
       width: "10%",
       field: "action",
       textAlign: "center",
       rowAlign: "center",
       contents:{
         // fetcher:getData,
         id:"supplierId",
         removeValue:"refNumber",
         url:`/suppliers/`,
         moduleName:"suppliers",
         from:`/contacts/consultants`,
         editLink:`/contacts/consultants/edit/`,
         viewLink:`/contacts/consultants/view/`
  
       }
     },
   ];
   const availableHeaders = [
   
   ];

 const [exportValue, setExportValue] = useState({
  performanceRating:"",
      vendorType:"",
      category:"",
      vendorStatus:"",
   
      country:"",
 });
const ExportFormik = useFormik({
  enableReinitialize: true,
  initialValues: exportValue,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: async (value, { setSubmitting }) => {
    try {
      const response = await axiosInstance.get(
        `/suppliers/export?category=${value.category}&vendorType=${value.vendorType}&performanceRating=${value.performanceRating}&country=${value.country}&vendorStatus=${value.vendorStatus}`,
        { responseType: "blob" }
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `Consultant Report ${formatDate(new Date())}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      setSubmitting(false); // ✅ spinner stops no matter what
    }
  },
});

 const closeFilterDialogebox = () => {
   setShowExport(false);
 };
  
   const [showEdit, setShowEdit] = useState(false)
   const [showDelete, setShowDelete] = useState(false)
   const [listofNumbers, setListofNumbers] = useState([])
   const [fullList, setFullList] = useState([])
  
   const selectOneFunction = (value) =>{ 
     let NewId;
     if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
       NewId = listofNumbers.filter(Temp=> Temp !== value);
       setListofNumbers(NewId)
     }else{
       setListofNumbers([...listofNumbers,value])
     }
   }
  
   const selectMultipleFunction = (e) =>{ 
  
     if(e.target.checked){
       setListofNumbers(fullList)
     }else{
       setListofNumbers([])
     }
     
  
       }
  
       useEffect(()=>{
         setParams({...params,page:page,per_page:pageCount})
        },[page,pageCount])
     
  
       const closeFilterDialog = () => {
         setShowFilterDialog(false);
       };
   const [showImportModal, setShowImportModal] = useState(false);
  
  
   const handleImportClick = () => {
     setShowImportModal(true);
   };
  
   const closeModal = () => {
     setShowImportModal(false);
   };
  
   useEffect(()=>{
     let tempArr = []
     data && data.forEach(i=>{
      
       tempArr.push(i?.supplierId)
     });
     setFullList(tempArr)
   },[data])
  
   const [valueOfSearch,setValuesofSearch] = useState("")
    function searchFunction(e) {
  
      
      setValuesofSearch(e?.target?.value)
      setParams({ ...params, search: e?.target?.value, page:1 });
      setPage(1)
    }
  
  
  
   return (
     <>
     <ContactsLayout 
       setOpen={setShowImportModal}
       searchFun={searchFunction}
       searchValue={valueOfSearch}
  
       // getData={getData}
       isFilter={filter}
       neededSearch={true}
       newfilter={true}
   officeId={officeId}
  
       setFilterOpen={setShowFilterDialog}
       ClearFilter={clearFilter}
       CreateAccess={GetAccess("consultants_create")}
       ImportAccess={GetAccess("consultants_import")}
      ExportAccess={GetAccess("consultants_export")}
      setOpenExport={setShowExport}
      setViewMode={setViewMode}
      viewMode={viewMode}
 isCard={true}
      total={totalCount}

       
       // officeId={officeId}
       // projectID={projectID}
         >
  
  
          
  {
   screenSize.width <= "786" ?(<>
   <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
   <MobileConsultIndex
   data={data}
   total={totalCount}
   pageIndex={page}
   setPageIndex={setPage}
   dataCount={pageCount}
   setDataCount={setPageCount}
   officeId={officeId}
   getData={getData}
   
  
   />
   </div>
   </>):(<>
  
  
     <div className='w-full h-full  '>
       {/* <div className='w-full flex justify-between items-center'>
         <Breadcrumb
           items={[
             { name: "Procurement" },
             { name: "YPR" },
           ]} />
         <div className=' flex gap-2'>
         <SearchBar
               handleChange={(e) =>{
                 setParams({ ...params, search: e.target.value, page:1 });
                 setPage(1)
               }}
               value={params.search||searchQuery}
             />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
           {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
         
           {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
           {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
         </div>
       </div> */}
  {viewMode === "list" ? (
  
       <CustomDataTable 
       fetcher={getData}
         data={data} 
         availableHeaders={availableHeaders} 
         defaultHeader={defaultHeader}
         bodyHeight='max-h-[calc(100vh-260px)]'
         height='h-[calc(100vh-160px)]'
         total={totalCount}
         pageIndex={page}
         setPageIndex={setPage}
         dataCount={pageCount}
         setDataCount={setPageCount}
         title='Consultants'
         storageName="consultantsTable"
         selectOneFunction={selectOneFunction}
         setShowDelete={setShowDelete}
         showDelete={showDelete}
         setShowEdit={setShowEdit}
         showEdit={showEdit}
         listofNumbers={listofNumbers}
         hasMultiEdit={true}
         selectMultipleFunction={selectMultipleFunction}
         fullList={fullList}
         getById="supplierId"
         editAccess="consultants_edit"      
         deteleAccess="consultants_delete" 
         dataLoading={dataLoading}
         searchQuery={params?.search!=""?params?.search:""}
         // dateShow={true}
         />
        ) : (
          <>
          <div className='w-full h-[calc(100vh-210px)] lg:h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-0.5 relative overflow-y-scroll'>
         {/* <div className='flex gap-40'> */}
        
          {/* <p className='text-xs font-semibold text-[#111537] text-left'>Consultant : {totalCount}</p> */}
          {/* <p className='text-sm'>Credit : {}</p>
           <p className='text-sm'>Advance : {}</p>
           */}
  
         
          {/* </div> */}
            <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
              
              {data && data.map((item, idx) => (
                <ConsultantCard fetcher={getData} item={item} key={idx} />
              ))}
            </div>
          </div>
          <div className="w-full h-[40px] rounded-b-md bg-white">
            <Pagination
              total={totalCount}
              pageIndex={page}
              setPageIndex={setPage}
              dataCount={pageCount}
              setDataCount={setPageCount}
            />
          </div>
          </>
        )}
     </div>
  
  </>)}
  
   
  
         </ContactsLayout>
  
         {showFilterDialog && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
              <h2 className="text-xl mb-4">Filter </h2>
              <form onSubmit={formik.handleSubmit}>
                <div className="flex flex-col mb-4">
                {/* <FormikSelectTwo
                                 label="Category"
                                 placeholder="Choose"
                                 Options={Category}
                                 formik={formik}
                                 name="category"
                                 width="w-full"
                                 getFunc={refCategory}
                                 displayProperty={"Category"}
                                 propertyName={"Category_Contractor"}
                               /> */}
  
  <FormikSelectTwo
                                 label="Type"
                                 placeholder="Choose"
                                 Options={Type}
                                 formik={formik}
                                 name="vendorType"
                                 width="w-full"
                                 getFunc={refType}
                                 displayProperty={"Type"}
                                 propertyName={"Type_Contractor"}
                               />

                                {/* <FormikSelectTwo
                                                                Options={Rating}
                                                                label="Ratings"
                                                                placeholder="Ratings"
                                                                formik={formik}
                                                                name="performanceRating"
                                                                width="w-full"
                                                                // getFunc={refDeliveryTerms}
                                                                displayProperty={"Performance Rating"}
                                                                propertyName={"ratings"}
                                                              /> */}

{/* <FormikSelectTwo
                                 type="text"
                                 label="Country"
                                 placeholder="Country"
                                 Options={CountryMIN}
                                 formik={formik}
                                 name="country"
                                 width="w-full"
                                 FixPosition={false}
                                 PortalTarget={false}
                               /> */}

<FormikSelectTwo
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={formik}
                  name="vendorStatus"
                  width="w-full"
                  getFunc={refStatus}
                  displayProperty={"Status"}
                  propertyName={"statusClient"}
                />
                </div>
                <div className="flex justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialog} />
                                 <SubmitButton name="Apply" isLoading={formik.isSubmitting} />

                </div>
              </form>
            </div>
          </div>
        )}
  
        {showEdit && (
          <MultiEditConslt
            data={listofNumbers}
            getData={getData}
            onClose={() => setShowEdit(false)}
          />
        )}
        {showImportModal && (
          <ImportFileModal
          show={showImportModal}
          onClose={closeModal}
        apiUrl="/suppliers/import/4"
        menuName="Consultant"
        getData={getData}
        />
        )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                   {/* <FormikSelectTwo
                                 label="Category"
                                 placeholder="Choose"
                                 Options={Category}
                                 formik={ExportFormik}
                                 name="category"
                                 width="sm:w-1/2 w-full"
                                 getFunc={refCategory}
                                 displayProperty={"Category"}
                                 propertyName={"Category_Contractor"}
                               /> */}
  
  <FormikSelectTwo
                                 label="Type"
                                 placeholder="Choose"
                                 Options={Type}
                                 formik={ExportFormik}
                                 name="vendorType"
                                 width="sm:w-1/2 w-full"
                                 getFunc={refType}
                                 displayProperty={"Type"}
                                 propertyName={"Type_Contractor"}
                               />

                                {/* <FormikSelectTwo
                                                                Options={Rating}
                                                                label="Ratings"
                                                                placeholder="Ratings"
                                                                formik={ExportFormik}
                                                                name="performanceRating"
                                                                width="sm:w-1/2 w-full"
                                                                // getFunc={refDeliveryTerms}
                                                                displayProperty={"Performance Rating"}
                                                                propertyName={"ratings"}
                                                              />

<FormikSelectTwo
                                 type="text"
                                 label="Country"
                                 placeholder="Country"
                                 Options={CountryMIN}
                                 formik={ExportFormik}
                                 name="country"
                                 width="sm:w-1/2 w-full"
                                 FixPosition={false}
                                 PortalTarget={false}
                               /> */}

<FormikSelectTwo
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={ExportFormik}
                  name="vendorStatus"
                  width="sm:w-1/2 w-full"
                  getFunc={refStatus}
                  displayProperty={"Status"}
                  propertyName={"statusClient"}
                />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                <SubmitButton name="Export" isLoading={ExportFormik.isSubmitting} />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
  
         
     </>
   )
}

export default ConsultantsIndex;

